export default "__VITE_ASSET__pRx1H01g__"